import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32488e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contactsTitle" }
const _hoisted_2 = {
  class: "checked_label",
  style: {"width":"100%"}
}

import { ref, computed } from 'vue'
import { findAdvertC, companyDropdown, pushQuotation } from '../loginApi'
import robotVerify from './robotVerify.vue';
import { ElMessage } from 'element-plus';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
type dynamicObjType = { key: string; type: string; prop: string; label: string; maxlength?: number; hide?: boolean; slot?: boolean, span?:number; placeholder?: string; options?: any; rules?: any; }

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseForm',
  emits: ['handleRoute'],
  setup(__props, { emit }) {

const { t } = useI18n();
const store = useStore();
const getLanguageValue = computed(() => store.getters.getLanguageValue);

const dynamicForm = ref({
  email: '',
  name: '',
  phone: '',
  vehicleNum: '',
  company: '',
  companyBiz: [],
  business: '',
  remark: '',
  productServices: [],
})
const loading = ref(false)
const companyList = ref<any>([])
const checkboxList = ref<any>([])
const dynamicList = ref<dynamicObjType[]>([
  {
    key: 'name',
    prop: 'name',
    type: 'input',
    maxlength: 50,
    label: t('login.contact.contacts'),
    rules: [{ required: true, message: t('login.input') + t('login.contact.contacts').toLowerCase() }]
  },
  
  {
    key: 'phone',
    prop: 'phone',
    type: 'input',
    maxlength: 20,
    label: t('login.contact.phone'),
    rules: [{
      required: true,
      validator: (_rule, value, callback) => {
        if (value) {
          const message = validatePhone(value) ? '' : t('login.contact.phoneErr')
          if (message) {
            callback(message)
          } else {
            callback()
          }
        } else if(!value) {
          return callback(t('login.input') + t('login.contact.phone').toLowerCase())
        }
      }
    }]
  },
  {
    key: 'email',
    prop: 'email',
    type: 'input',
    maxlength: 100,
    label: t('login.email'),
    rules: [{
      validator: (_rule, value, callback) => {
        if (value) {
          const message = validateEmail(value) ? '' : t('login.contact.emailErr')
          // return callback(message)
          if (message) {
            callback(message)
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    }]
  },
  {
    key: 'company',
    prop: 'company',
    type: 'input',
    maxlength: 150,
    label: t('login.companyName')
  },  
  {
    key: 'companyBiz',
    prop: 'companyBiz',
    type: 'select',
    label: t('login.contact.companyBusiness'),
    rules: [{
      required: true,
      validator: (_rule, value, callback) => {
        if (value.length) {
          callback()
        } else {
          return callback(t('login.choose') + t('login.contact.companyBusiness').toLowerCase())
        }
      }
     }]
  },
  {
    key: 'vehicleNum',
    prop: 'vehicleNum',
    type: 'input',
    maxlength: 5,
    label: t('login.contact.carsNum'),
    rules: [{
      required: true,
      validator: (_rule, value, callback) => {
        if (value) {
          const message = isPositiveInteger(value) ? '' : t('login.contact.numberErr')
          if (message) {
            callback(message)
          } else {
            callback()
          }
          callback()
        } else {
          return callback(t('login.input') + t('login.contact.carsNum').toLowerCase())
        }
      }
     }]
  },
  {
    key: 'business',
    prop: 'business',
    type: 'input',
    hide: true,
    span: 24,
    label: t('login.contact.business'),
    rules: [{ required: true, message: t('login.input') + t('login.contact.business').toLowerCase() }]
  },
  {
    key: 'productServices',
    prop: 'productServices',
    type: 'checkbox',
    span: 24,
    slot: true,
    label: t('login.contact.product'),
    rules: [{
      required: true,
      validator: (_rule, value, callback) => {
        if (value.length) {
          callback()
        } else {
          return callback(t('login.choose') + t('login.contact.product').toLowerCase())
        }
      }
    }]
  },
  {
    key: 'remark',
    prop: 'remark',
    type: 'textarea',
    span: 24,
    maxlength: 250,
    label: t('login.contact.remark')
  },
])

// 郵箱验证
function validateEmail(email: string) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return regex.test(email)
}
// 电话
function validatePhone(value: string) {
  const regex = /^1[3456789]\d{9}$|^[6]([8|6])\d{5}|^((0\d{2,3})-)?(\d{7,8})$/
  return regex.test(value)
}
// 正整数
function isPositiveInteger(value: string) {
    const regex = /^[1-9]\d*$/; // 正则表达式，匹配正整数
    return regex.test(value);
}

let otherItem:any = {}
const init = () => {
  companyDropdown().then(res => {
    companyList.value = res.data
    res.data.forEach(item => {
      if (item && item.remark == 'other_business') otherItem = item
    })
  })
  findAdvertC().then(res => {
    checkboxList.value = res.data
  })
}
init()

let isBusiness = true
const handleChange = (e) => {
  const result = e.map(id => {
    const found = companyList.value.find(item => item.id === id);
    return found && found.remark == 'other_business' ? found : null; 
  }).filter(name => name)
  // const result = companyList.value.find(item => item.id === e)
  dynamicList.value.forEach((item => {
    if (item.key == 'business') {
      item.hide = result && result.length > 0 ? false : true
      isBusiness = result && result.length > 0 ? false : true
    } 
  }))
}

const formRef = ref<any>(null)
const robotVerifyOpen = ref(false)
const handleSave = async () => {
  loading.value = true
  const productservices = dynamicForm.value.productServices.map(id => {
    const found = checkboxList.value.find(item => item.id === id);
    return found ? found.name : null; 
  }).filter(name => name !== null).join('、')
  // const  = companyList.value.find(item => item.id === dynamicForm.value.companyBiz)
  const companyBiz = dynamicForm.value.companyBiz.map(id => {
    const found = companyList.value.find(item => item.id === id);
    return found ? found.remark == 'other_business' ? null : found.name : null; 
  }).filter(name => name !== null).join('、')
  const parmas = {
    ...dynamicForm.value,
    productServices: productservices,
    companyBiz: isBusiness ? companyBiz : `${companyBiz}、${otherItem.name}（${dynamicForm.value.business}）`
  }
  pushQuotation(parmas).then(res => {
    ElMessage.success(res.resultMessage)
    emit('handleRoute',{ id: 'home', name: t('login.home') },0)
    loading.value = false
  }).catch(() => {
    loading.value = false
  })
}

/* 保存前验证工作 */
const submitBefore = () => {
  formRef.value.validate((valid: any) => {
    if (valid) {
      robotVerifyOpen.value = true
    }
  })
}



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('login.contact.contactsTitle')), 1),
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: dynamicForm.value,
        "label-width": "auto",
        class: "demo-dynamic",
        "label-position": "left",
        size: "large"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dynamicList.value, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.key
                }, [
                  (!item.hide)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        span: item.span || 12
                      }, {
                        default: _withCtx(() => [
                          (!item.slot)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                prop: item.prop,
                                label: item.label,
                                rules: item.rules
                              }, {
                                default: _withCtx(() => [
                                  (item.type === 'input')
                                    ? (_openBlock(), _createBlock(_component_el_input, {
                                        key: 0,
                                        required: "",
                                        maxlength: item.maxlength,
                                        "show-word-limit": "",
                                        class: "baseInputbox",
                                        style: {"width":"100%"},
                                        modelValue: dynamicForm.value[item.key],
                                        "onUpdate:modelValue": ($event: any) => ((dynamicForm.value[item.key]) = $event),
                                        placeholder: item.placeholder || _ctx.$t('login.input') + item.label.toLowerCase()
                                      }, null, 8, ["maxlength", "modelValue", "onUpdate:modelValue", "placeholder"]))
                                    : (item.type === 'select')
                                      ? (_openBlock(), _createBlock(_component_el_select, {
                                          key: 1,
                                          multiple: "",
                                          clearable: "",
                                          "collapse-tags": "",
                                          "collapse-tags-tooltip": "",
                                          class: "baseInputbox",
                                          onChange: handleChange,
                                          style: {"width":"100%"},
                                          modelValue: dynamicForm.value[item.key],
                                          "onUpdate:modelValue": ($event: any) => ((dynamicForm.value[item.key]) = $event),
                                          placeholder: item.placeholder || _ctx.$t('login.select') + item.label.toLowerCase()
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyList.value, (ele) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: ele.id,
                                                label: ele.name,
                                                value: ele.id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                                      : (item.type === 'textarea')
                                        ? (_openBlock(), _createBlock(_component_el_input, {
                                            key: 2,
                                            class: "baseInputbox",
                                            modelValue: dynamicForm.value[item.key],
                                            "onUpdate:modelValue": ($event: any) => ((dynamicForm.value[item.key]) = $event),
                                            style: {"width":"100%"},
                                            maxlength: item.maxlength,
                                            "show-word-limit": "",
                                            autosize: { maxRows: 2 },
                                            type: "textarea",
                                            placeholder: item.placeholder || _ctx.$t('login.input') + item.label.toLowerCase()
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "maxlength", "placeholder"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["prop", "label", "rules"]))
                            : (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 1,
                                class: "checked-form-item",
                                prop: item.prop,
                                rules: item.rules
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, _toDisplayString(item.label), 1),
                                  _createVNode(_component_el_checkbox_group, {
                                    size: "large",
                                    modelValue: dynamicForm.value.productServices,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dynamicForm.value.productServices) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkboxList.value, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_checkbox, {
                                          style: _normalizeStyle({minWidth: getLanguageValue.value == 'en' ? '47%' : '30%'}),
                                          value: item.id,
                                          label: item.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["style", "value", "label"]))
                                      }), 256))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["prop", "rules"]))
                        ]),
                        _: 2
                      }, 1032, ["span"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", {
        class: "enter",
        onClick: submitBefore
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t('login.contact.submitForm')) + " ", 1),
        (loading.value)
          ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 0,
              class: "el-icon is-loading",
              style: {"margin-left":"5px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Loading)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    (robotVerifyOpen.value)
      ? (_openBlock(), _createBlock(robotVerify, {
          key: 0,
          visible: robotVerifyOpen.value,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((robotVerifyOpen).value = $event)),
          onSuccess: handleSave
        }, null, 8, ["visible"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})